import { Box, Typography, Container } from "@mui/material";
import { Mail, Linkedin } from "lucide-react";
import { Instagram } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNewsletterClick = () => {
    if (location.pathname === "/newsletter") {
      // Si ya estamos en /newsletter, solo hacer scroll
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      // Si estamos en otra página, navegar y luego hacer scroll
      navigate("/newsletter", { replace: false });
      // Usar setTimeout para asegurar que la navegación se complete antes del scroll
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    }
  };

  return (
    <Box
      id="contacto"
      sx={{
        width: "100%",
        maxWidth: "100vw",
        overflowX: "hidden",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "1px",
          backgroundColor: "rgba(74, 106, 74, 0.12)",
          mt: { xs: 2, sm: 2.5 },
          mb: { xs: 3, sm: 3.5 },
        }}
      />
      <Container
        maxWidth="md"
        sx={{
          position: "relative",
          zIndex: 1,
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            pt: { xs: 2, sm: 2.5 },
            pb: { xs: 2, sm: 2.5 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: 2, sm: 2.5 },
          }}
        >
          <Typography
            component="button"
            onClick={handleNewsletterClick}
            sx={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: 0,
              font: "inherit",
              textDecoration: "none",
              color: "text.primary",
              fontSize: { xs: "0.648rem", sm: "0.72rem", md: "0.756rem" },
              fontWeight: 500,
              textTransform: "uppercase",
              transition: "opacity 0.2s ease",
              "&:hover": {
                opacity: 0.7,
                textDecoration: "underline",
              },
            }}
          >
            ÚNETE A NUESTRO NEWSLETTER
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: { xs: 1, sm: 1.25 },
              justifyContent: "center",
            }}
          >
            <Box
              component="a"
              href="https://www.instagram.com/huelmu/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "primary.main",
                transition: "opacity 0.2s ease",
                "&:hover": {
                  opacity: 0.7,
                },
              }}
            >
              <Instagram sx={{ fontSize: 14, color: "#4a6a4a" }} />
            </Box>

            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                fontSize: { xs: "0.8rem", sm: "0.85rem", md: "0.9rem" },
                lineHeight: 1,
              }}
            >
              ·
            </Typography>

            <Box
              component="a"
              href="https://linkedin.com/company/huelmu"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "primary.main",
                transition: "opacity 0.2s ease",
                "&:hover": {
                  opacity: 0.7,
                },
              }}
            >
              <Linkedin size={14} color="#4a6a4a" />
            </Box>

            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                fontSize: { xs: "0.8rem", sm: "0.85rem", md: "0.9rem" },
                lineHeight: 1,
              }}
            >
              ·
            </Typography>

            <Box
              component="a"
              href="mailto:contacto@huelmu.cl"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "primary.main",
                transition: "opacity 0.2s ease",
                "&:hover": {
                  opacity: 0.7,
                },
              }}
            >
              <Mail size={14} color="#4a6a4a" />
            </Box>
          </Box>

          <Typography
            variant="body2"
            sx={{
              color: "text.disabled",
              fontSize: { xs: "0.65rem", sm: "0.7rem", md: "0.75rem" },
              lineHeight: 1.4,
              opacity: 0.5,
              textAlign: "center",
              mt: { xs: 1, sm: 1.5 },
            }}
          >
            Huelmu · Impacto real, transparente y con sentido
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
